/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface StripeConstantsDTO
 */
export interface StripeConstantsDTOOptional {
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  publicKey?: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  account?: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  apiVersion?: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  locale?: string;
}

export interface StripeConstantsDTO extends StripeConstantsDTOOptional {
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  publicKey: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  account: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  apiVersion: string;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  locale: string;
}

export interface StripeConstantsDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  publicKey?: string;
  publicKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  account?: string;
  accountIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  apiVersion?: string;
  apiVersionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeConstantsDTO
   */
  locale?: string;
  localeIsSet: boolean;
}

transformDatesMap.set(
  "StripeConstantsDTO",
  function (model: StripeConstantsDTO) {},
);

export type StripeConstantsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  publicKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  account: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  apiVersion: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  locale: PropertyMeta<MetaTypeBase<string>>;
}>;

export var StripeConstantsDTOMeta: StripeConstantsDTOMetaI =
  {} as StripeConstantsDTOMetaI;
StripeConstantsDTOMeta = typeMeta("StripeConstantsDTO", {
  publicKey: propertyMeta(
    "publicKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  account: propertyMeta("account", false, true, false, MetaTypesBase.string),
  apiVersion: propertyMeta(
    "apiVersion",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  locale: propertyMeta("locale", false, true, false, MetaTypesBase.string),
});

const metaI = StripeConstantsDTOMeta;

registerMeta(() => {});

export class StripeConstantsDTOTracked implements StripeConstantsDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  publicKey__I?: string = undefined;
  publicKeyIsSet: boolean = false;
  set publicKey(v: undefined | string) {
    if (v !== undefined) {
      this.publicKey__I = v;
      this.publicKeyIsSet = true;
    } else {
      this.publicKey__I = v || undefined;
      this.publicKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get publicKey() {
    return this.publicKey__I;
  }
  account__I?: string = undefined;
  accountIsSet: boolean = false;
  set account(v: undefined | string) {
    if (v !== undefined) {
      this.account__I = v;
      this.accountIsSet = true;
    } else {
      this.account__I = v || undefined;
      this.accountIsSet = true;
    }
    this.changeTracker = true;
  }
  get account() {
    return this.account__I;
  }
  apiVersion__I?: string = undefined;
  apiVersionIsSet: boolean = false;
  set apiVersion(v: undefined | string) {
    if (v !== undefined) {
      this.apiVersion__I = v;
      this.apiVersionIsSet = true;
    } else {
      this.apiVersion__I = v || undefined;
      this.apiVersionIsSet = true;
    }
    this.changeTracker = true;
  }
  get apiVersion() {
    return this.apiVersion__I;
  }
  locale__I?: string = undefined;
  localeIsSet: boolean = false;
  set locale(v: undefined | string) {
    if (v !== undefined) {
      this.locale__I = v;
      this.localeIsSet = true;
    } else {
      this.locale__I = v || undefined;
      this.localeIsSet = true;
    }
    this.changeTracker = true;
  }
  get locale() {
    return this.locale__I;
  }
  constructor(config?: StripeConstantsDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: StripeConstantsDTOOptional,
    options?: AssignOptions,
  ): StripeConstantsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.publicKey && this.publicKeyApplyFilter(optionsRequired.filter)) {
      this.publicKey = config.publicKey;
      if (optionsRequired.unassign) this.publicKeyIsSet = false;
      else this.publicKeyIsSet = true;
    }
    if (config.account && this.accountApplyFilter(optionsRequired.filter)) {
      this.account = config.account;
      if (optionsRequired.unassign) this.accountIsSet = false;
      else this.accountIsSet = true;
    }
    if (
      config.apiVersion &&
      this.apiVersionApplyFilter(optionsRequired.filter)
    ) {
      this.apiVersion = config.apiVersion;
      if (optionsRequired.unassign) this.apiVersionIsSet = false;
      else this.apiVersionIsSet = true;
    }
    if (config.locale && this.localeApplyFilter(optionsRequired.filter)) {
      this.locale = config.locale;
      if (optionsRequired.unassign) this.localeIsSet = false;
      else this.localeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StripeConstantsDTOTrackedI {
    const cloned = {} as StripeConstantsDTOTrackedI;
    if (
      this.publicKeyIsSetDeep() &&
      this.publicKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.publicKeyIsSet = true;
      cloned.publicKey = this.publicKey;
    } else {
      //cloned.publicKeyIsSet = false
    }
    if (
      this.accountIsSetDeep() &&
      this.accountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.accountIsSet = true;
      cloned.account = this.account;
    } else {
      //cloned.accountIsSet = false
    }
    if (
      this.apiVersionIsSetDeep() &&
      this.apiVersionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.apiVersionIsSet = true;
      cloned.apiVersion = this.apiVersion;
    } else {
      //cloned.apiVersionIsSet = false
    }
    if (
      this.localeIsSetDeep() &&
      this.localeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.localeIsSet = true;
      cloned.locale = this.locale;
    } else {
      //cloned.localeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StripeConstantsDTOTrackedI {
    if (!this.publicKeyApplyFilter(filter)) this.publicKeyIsSet = false;

    if (!this.accountApplyFilter(filter)) this.accountIsSet = false;

    if (!this.apiVersionApplyFilter(filter)) this.apiVersionIsSet = false;

    if (!this.localeApplyFilter(filter)) this.localeIsSet = false;

    return this;
  }
  publicKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeConstantsDTOMeta.publicKey,
      StripeConstantsDTOMeta,
      this.publicKey,
      this,
    );
  }
  publicKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.publicKeyIsSet && this.publicKeyApplyFilter(filter)) return true;

    return false;
  }
  accountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeConstantsDTOMeta.account,
      StripeConstantsDTOMeta,
      this.account,
      this,
    );
  }
  accountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.accountIsSet && this.accountApplyFilter(filter)) return true;

    return false;
  }
  apiVersionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeConstantsDTOMeta.apiVersion,
      StripeConstantsDTOMeta,
      this.apiVersion,
      this,
    );
  }
  apiVersionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.apiVersionIsSet && this.apiVersionApplyFilter(filter)) return true;

    return false;
  }
  localeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeConstantsDTOMeta.locale,
      StripeConstantsDTOMeta,
      this.locale,
      this,
    );
  }
  localeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.localeIsSet && this.localeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.publicKeyIsSetDeep(filter)) return true;
    if (this.accountIsSetDeep(filter)) return true;
    if (this.apiVersionIsSetDeep(filter)) return true;
    if (this.localeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
